module.exports = __webpack_public_path__ + "static/lisa-a841a0fd58100b630d5a1271b1d741a5.png";